<template>
    <div ref="overlay" class="Overlay">
        <div ref="container" class="Overlay__container">  
            <Cristal v-if="ready"/> 
            <div class="Overlay__block top">
                <div class="Overlay__logo">MOMENTA Biennale de l'image</div>
                <div class="Overlay__title" v-html="trans('FONT.title')"/>
                <div class="Overlay__sub" v-html="trans('FONT.subtitle')"/>
            </div>
            <div class="Overlay__block bottom">
                <div class="Overlay__desc" v-html="trans('GLOBAL.description')"/>
                <div class="Overlay__button" @click="onClick()" v-html="trans('GLOBAL.explore')"/>  
                <div class="Overlay__arrow"><img :src="require('@/commons/img/arrow.png')"></div>
            </div>
            <div ref="explored" class="Overlay__trigger"/>
        </div>     
    </div>
</template>

<script>

import Mixin from '@/mixins/Smooth.js'
import Cristal from '@/components/Cristal.vue'
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import Draggable from "gsap/Draggable"
import MotionPathPlugin from "gsap/MotionPathPlugin"
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, Draggable, MotionPathPlugin, ScrollToPlugin)

export default {

    name: 'Overlay',
    mixins: [Mixin],
    components: { Cristal },
    data: ()=>({
        ready: false
    }),
    beforeDestroy() {    
        this.$scr.kill()
    },
    mounted() {
        gsap.from('.Overlay__logo', { duration: .75, alpha: 0, delay: .5 })
        gsap.from(['.Overlay__title', '.Overlay__sub', '.Overlay__desc', '.Overlay__button', '.Overlay__arrow'], 
            {   
                y: 200, 
                ease: "cubic.out", 
                alpha: 0, 
                delay: 1,
                stagger: .15 
            })
        gsap.delayedCall(3, ()=> this.ready = true)
        this.$nextTick(()=>{
            this.$scr = ScrollTrigger.create({
                scroller: '.Overlay',
                trigger: '.Overlay__trigger',
                toggleActions: "restart pause reverse none",
                ease: 'cubic.out',
                scrub: true,
                onEnter: ()=>{
                    this.hideIt()
                }     
            }) 

            let tl = gsap.to('.Overlay__arrow', { duration: 1, paddingTop: '+=200' })

            ScrollTrigger.create({
                scroller: '.Overlay',
                trigger: '.Overlay__arrow',
                toggleActions: "restart pause reverse none",
                scrub: true,
                animation: tl
            })
        })
    },
    methods: { 
        onClick() {
           gsap.delayedCall(.1, ()=>{
                 // this.hideIt()

                gsap.to('.Overlay', {
                    scrollTo: {
                      y: document.querySelector('.Overlay__trigger'),
                      autoKill: false
                    },
                    duration: 1,
                    ease: 'cubic.easeOut',
                    delay: .1
                })
           })  
        },
        hideIt() {
            gsap.to(this.$refs.overlay, { duration: .5, alpha: 0, onComplete: ()=> this.$parent.welcome = false })
        }
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Overlay 
    display flex
    position absolute
    top 0
    left 0
    width 100vw
    height 100%
    overflow scroll
    z-index 1000
    background-color rgba(#ffffff, 1)
    font-family Ringside
    font-weight 200
    color black

    &__container
        display flex
        align-items center
        justify-content flex-start
        flex-direction column
        position relative
        height 140%
        width 100%
        top 0
        transition transform .35s
     
    &__block 
        height 42vh
        &.top 
            display flex
            flex-direction column
            position relative
            align-items center
            justify-content space-around
        &.bottom 
            display flex
            flex-direction column
            position relative
            align-items center
            justify-content flex-end
            font-family Ringside
            font-size 14px
        & img
            width 100%

    &__logo 
        padding-top 16px
        font-weight 700
        text-transform uppercase
        font-size 15px

    &__arrow
        padding-top 16px

    &__title
    &__sub
        font-family Jugendreisen
        text-align center

    &__title
        font-size 44px
        line-height 52px
        text-transform uppercase
    &__sub
        font-size 16px
        text-transform uppercase

    &__desc
        padding 0 24px 24px
        text-align center
        font-size 13px

    &__button 
        cursor pointer
        background rgb(245,180,197)
        background linear-gradient(90deg, rgba(245,180,197,1) 0%, rgba(252,228,231,1) 75%, rgba(232,219,223,1) 100%)
        padding 12px 24px
        border-radius 24px

    &__trigger
        width 20vw
        height 50px
        // border 1px solid red
        bottom 50px
        position absolute
              
</style>














